<script>
    export let response = {};
    $: status = response && response.status;
    $: message = response && response.message;
</script>

{#if message !== undefined && status !== undefined}
    <div
        class:bg-danger={!status}
        class:bg-success={status}
        class="inline-message"
    >
        {message}
        <button
            type="button"
            class="close close-button"
            data-dismiss="alert"
            aria-label="Close"
            on:click={() => (response = {})}
            ><span aria-hidden="true">&times;</span></button
        >
    </div>
{/if}

<style>
    .inline-message {
        padding-top: 6px;
        padding-bottom: 6px;
        padding-left: 20px;
        display: inline-block;
        vertical-align: botom;
    }
    .close-button {
        margin-left: 10px;
        padding-right: 6px;
    }
</style>
